var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 627,
    height: 454,
    viewBox: "0 0 627 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M498.382 162.327L621.358 90.9817L536.904 43.9785L420.203 112.737",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M420.196 112.737L418.332 113.834",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M414.699 115.973L351.113 153.437",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10,
    strokeDasharray: "6.56 6.56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M349.294 154.509L347.43 155.605L349.301 156.688",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M353 158.821L425.218 200.461",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10,
    strokeDasharray: "6.56 6.56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M427.074 201.524L428.945 202.608L430.816 201.524",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M434.68 199.279L494.569 164.532",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10,
    strokeDasharray: "6.56 6.56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M496.504 163.41L498.375 162.327",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M347.43 403.828L428.943 450.825L621.355 339.199L536.9 292.202L347.43 403.828Z",
    stroke: "#231F20",
    strokeWidth: 2.15978,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M347.895 403.828L429.408 450.825L621.813 339.199L537.365 292.202L347.895 403.828Z",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M428.945 325.834V450.826",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M536.168 43.9785V292.203",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M621.27 90.9023V339.12",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M347.43 282.205V403.009",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M347.43 154.791V282.205",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10,
    strokeDasharray: "6.56 6.56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M135.886 181.036C156.204 181.036 172.675 164.565 172.675 144.248C172.675 123.93 156.204 107.459 135.886 107.459C115.568 107.459 99.0977 123.93 99.0977 144.248C99.0977 164.565 115.568 181.036 135.886 181.036Z",
    fill: "#F8EB30"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M404.111 326.411L420.194 335.674L420.161 379.546L403.789 369.777L404.111 326.411Z",
    stroke: "white",
    strokeWidth: 1.08317,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M381.345 312.823L397.429 322.086L397.396 365.964L381.023 356.196L381.345 312.823Z",
    stroke: "white",
    strokeWidth: 1.08317,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M359.529 299.266L375.612 308.528L375.579 352.407L359.207 342.639L359.529 299.266Z",
    stroke: "white",
    strokeWidth: 1.08317,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M404.111 379.546L420.194 388.815L420.161 432.687L403.789 422.919L404.111 379.546Z",
    stroke: "white",
    strokeWidth: 1.08317,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M381.345 365.963L397.429 375.226L397.396 419.097L381.023 409.329L381.345 365.963Z",
    stroke: "white",
    strokeWidth: 1.08317,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M359.529 352.407L375.612 361.67L375.579 405.542L359.207 395.774L359.529 352.407Z",
    stroke: "white",
    strokeWidth: 1.08317,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M462.13 307.997L429.891 326.588L353.793 282.441L387.194 263.85L462.13 307.997Z",
    fill: "#F8EB30"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M493.535 246.014L461.289 264.605L385.191 220.451L418.593 201.866L493.535 246.014Z",
    fill: "#F8EB30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1 67.9598C5.40491 67.9598 399.227 287.49 399.227 287.49L598.787 1",
    stroke: "#F8EB30",
    strokeWidth: 2.15978,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M428.941 326.589V450.826",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M428.941 202.608V326.589",
    stroke: "white",
    strokeWidth: 4.32613,
    strokeMiterlimit: 10,
    strokeDasharray: "6.56 6.56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMd);
export default __webpack_public_path__ + "static/media/desktop-md.c4f281f51e3628834417ecb65ce78f25.svg";
export { ForwardRef as ReactComponent };